import Lookup from 'src/componentes/select-async';
import GrupoDiaEnvioEdit from 'src/paginas/matriz-orcamentaria/grupo-envio/edit';
import GrupoDiaEnvioList from 'src/paginas/matriz-orcamentaria/grupo-envio/view';

const GrupoDiaEnvioLookup = (props) => {
  return (
    <Lookup
      valueKey="id"
      labelKey="nome"
      showSearch
      clearable={true}
      url="/GrupoDiaEnvioLookup"
      editComponent={GrupoDiaEnvioEdit}
      searchComponent={GrupoDiaEnvioList}
      {...props}
    />
  );
};

export default GrupoDiaEnvioLookup;
